module.exports = __webpack_public_path__ + "img/online-course.59e65933.svg";